import initialState from './initialState';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import Immutable from 'immutable';
import createReducer from './createReducer';
import {SET_ACTIVELY_SELECTED_WORK_ORDER_ID} from "../constants/actionTypes";

const toggleDrawer = (state, action) => {

    state
        .get('drawers')
        .forEach((drawer, key) => {
            if (key !== action.id) {
                state = state.setIn([
                    'drawers', key
                ], false);
            }
        });

    if (action.isOpen !== null) {
        state = state.setIn([
            'drawers', action.id
        ], action.isOpen);
    } else {
        state = state.setIn([
            'drawers', action.id
        ], !state.getIn(['drawers', action.id]));
    }

    return state;

};

const setTheme = (state, action) => {
    return state
        .set('themeModifier', Immutable.fromJS(action.theme))
        .set('theme', Immutable.fromJS(getMuiTheme(action.theme)));
};

const rehydrate = (state, action) => {
    if (action.payload.site) {
        state = action.payload.site;
    }
    return state.set('stateReady', true);
};

const setOrderDetailType = (state, action) => {
    return state.set('orderDetailType', action.orderDetailType);
};

const setActivelySelectedWorkOrderId = (state, action) => {
  if (action.type === SET_ACTIVELY_SELECTED_WORK_ORDER_ID) {
    return state.set('activelySelectedWorkOrderId', action.workOrderId);
  }
};

const handlers = {
    'TOGGLE_DRAWER': toggleDrawer,
    'SET_THEME': setTheme,
    'persist/REHYDRATE': rehydrate,
    'SET_ORDER_DETAIL_TYPE': setOrderDetailType,
    'SET_ACTIVELY_SELECTED_WORK_ORDER_ID': setActivelySelectedWorkOrderId
};

export default createReducer(initialState.get('site'), handlers);



// WEBPACK FOOTER //
// ./src/reducers/siteReducer.js